import { Box } from '@mui/material';

const SidebarLayout = ({ children, sidebar }) => (
  <Box sx={{ display: 'flex', gap: sidebar ? 2.5 : 0 }}>
    <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>
    {sidebar}
  </Box>
);

export default SidebarLayout;
